import type { FilmPopup, Popup } from '../models/popup.types'

export const isFilmPopup = (popup: Popup): popup is FilmPopup => {
    return 'film' in popup
}
